<template>
  <!-- eslint-disable max-len -->
  <svg
    :style="`height: ${height}px; width: ${width}px;`"
    viewBox="0 0 51 51"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    class="not-sr-only"
  >
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <g transform="translate(-427 -677)">
        <g transform="translate(406 656)">
          <g transform="translate(10 10)">
            <path
              transform="translate(36.5 36.5) rotate(67) translate(-36.5 -36.5)"
              d="m36.5 10.624l18.297 7.579 7.579 18.297-7.579 18.297-18.297 7.579-18.297-7.579-7.579-18.297 7.579-18.297 18.297-7.579z"
              stroke="#336"
              stroke-width="3"
            />
            <g transform="translate(23 22)">
              <mask fill="white">
                <use xlink:href="#path-1" />
              </mask>
              <path
                d="m21.998 19.945c0-0.01898 0.0024807-0.036988 0.0020502-0.055968-0.023384-1.6537-0.088875-6.2903-0.088875-6.2903h-0.0029768l-0.11709-8.2813c-0.011411-0.81908-0.69212-1.4761-1.5251-1.4761-0.006946 0-0.014388 0-0.021334 4.8668e-4 -0.84245 0.01168-1.5162 0.6906-1.5048 1.517l0.11709 8.2813c-0.34333 0.0048667-0.708 0.0092469-1.09 0.0146l-0.15678-11.082c-0.011411-0.81957-0.69212-1.4766-1.5246-1.4766-0.0074421 0-0.014388 0-0.02183 4.8667e-4 -0.84245 0.01168-1.5162 0.6906-1.5048 1.5175l0.15678 11.082c-0.3597 0.0048667-0.72338 0.0097335-1.09 0.0146l-0.17315-12.235c-0.011411-0.81957-0.69212-1.4761-1.5246-1.4761-0.0074422 0-0.014388 0-0.02183 4.8668e-4 -0.84245 0.010707-1.5162 0.69011-1.5048 1.517l0.17315 12.235c-0.36863 0.0053534-0.73181 0.01022-1.09 0.015087l-0.15678-11.082c-0.011411-0.81957-0.69262-1.4761-1.5251-1.4761-0.006946 0-0.014388 0-0.021334 4.8668e-4 -0.84295 0.011194-1.5162 0.6906-1.5048 1.517l0.15678 11.083h-0.006946l0.030761 2.2509-1.0588 1.5106-2.439-6.523c-0.29024-0.77577-1.1649-1.1739-1.9578-0.89013-0.79135 0.28519-1.1977 1.1447-0.90745 1.9209l3.7876 10.129c1.0126 3.9713 4.6925 6.8909 9.0457 6.832 4.9852-0.068135 8.9787-4.0146 9.0625-8.8702 0.0024807-0.037961 0.010485-0.073975 0.0099229-0.11291l-0.0014885-0.11145z"
                fill="#336"
                mask="url(#mask-2)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SvgStopHand',
  props: {
    height: {
      type: Number,
      default: 64,
    },
    width: {
      type: Number,
      default: 64,
    },
  },
};
</script>
